<template>
  <UIButton ref="buttonRef" v-bind="{ size, variant, fill }">
    <template v-if="count" #trailing>
      <div class="ui-button-count">
        {{ count }}
      </div>
    </template>
  </UIButton>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'

import { ButtonFill, ButtonSize, ButtonVariant } from '@types'

import UIButton from './Button.vue'

type Props = {
  count?: number

  size?: ButtonSize
  variant?: ButtonVariant
  fill?: ButtonFill
}

const {
  count,
  size = 'default',
  variant = 'primary',
  fill = 'filled',
} = defineProps<Props>()

const buttonRef = useTemplateRef('buttonRef')

defineExpose({
  focus() {
    buttonRef.value?.focus()
  },
})
</script>

<style>
.ui-button-count {
  @apply w-[1.15rem] h-[1.15rem];
  @apply flex items-center justify-center;
  @apply shrink-0;
  @apply -ml-0.5 -my-1;
  @apply rounded-full;
  @apply text-[10px] font-bold;

  @apply text-[var(--button-count-text)];
  @apply bg-[var(--button-count-bg)];

  /* size/variant/fill classes can be added when needed. */
  /* For now only default styles are used in the app. */
}
</style>
